import { render } from "./PalworldModGuidelineView.vue?vue&type=template&id=47ad2a46"
import script from "./PalworldModGuidelineView.vue?vue&type=script&lang=js"
export * from "./PalworldModGuidelineView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__